// src/components/ai/copilot/AiDraftContextChips.js
import React from 'react';
import { MAX_FOCUS_TAGS } from '../../../utils/instructorCopilot';

/**
 * Tag/tone chip multi-selector for InstructorQuickAiDraftInput.
 * Mobile-friendly pill toggles.
 *
 * Props:
 *   availableTags   — [{ key: string, label: string }]
 *   selectedTags    — string[] — currently selected keys
 *   onChange        — (tags: string[]) => void
 *   maxSelected     — number (default MAX_FOCUS_TAGS)
 */
function AiDraftContextChips({
  availableTags = [],
  selectedTags = [],
  onChange,
  maxSelected = MAX_FOCUS_TAGS,
}) {
  const toggle = (key) => {
    if (selectedTags.includes(key)) {
      onChange?.(selectedTags.filter((t) => t !== key));
    } else if (selectedTags.length < maxSelected) {
      onChange?.([...selectedTags, key]);
    }
  };

  if (availableTags.length === 0) return null;

  return (
    <div>
      <p className="text-xs font-semibold text-slate-500">
        Focus areas
        {selectedTags.length > 0 ? (
          <span className="ml-2 font-normal text-slate-400">({selectedTags.length}/{maxSelected})</span>
        ) : null}
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        {availableTags.map(({ key, label }) => {
          const isSelected = selectedTags.includes(key);
          const isDisabled = !isSelected && selectedTags.length >= maxSelected;
          return (
            <button
              key={key}
              type="button"
              onClick={() => toggle(key)}
              disabled={isDisabled}
              className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                isSelected
                  ? 'bg-violet-600 text-white'
                  : isDisabled
                    ? 'cursor-not-allowed bg-slate-100 text-slate-300'
                    : 'bg-slate-100 text-slate-600 hover:bg-violet-100 hover:text-violet-700'
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default AiDraftContextChips;
